import { Props } from '@/components/@base/modal/action/type';
import Container from '@/components/@base/container';

export default function ModalAction({ children }: Props) {
  return <Container className='mt-4'>{children}</Container>;
}
